import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query'
import { useApi } from '../api/contexto'
import { ErrorApi } from '../api/errores'

/**
 * Configuración del sistema (Sistema › Configuración). El backend devuelve los
 * valores efectivos + las definiciones (qué pintar y cómo validar), así que la
 * pantalla se construye desde los datos sin hardcodear el formulario.
 */

export type TipoAjuste = 'numero' | 'texto' | 'email' | 'lista_email' | 'hora' | 'booleano'

export interface DefinicionAjuste {
  clave: string
  etiqueta: string
  tipo: TipoAjuste
  defecto: unknown
  min?: number
  max?: number
}

export interface ConfiguracionResp {
  valores: Record<string, unknown>
  definiciones: DefinicionAjuste[]
}

const RUTA = '/api/configuracion'

export function useConfiguracion() {
  const api = useApi()
  return useQuery<ConfiguracionResp, ErrorApi>({
    queryKey: ['configuracion'],
    queryFn: async ({ signal }) => {
      const datos = await api.pedir<ConfiguracionResp>(RUTA, { senal: signal })
      return datos ?? { valores: {}, definiciones: [] }
    },
    retry: (intentos, error) => {
      if (error instanceof ErrorApi && error.estado < 500) return false
      return intentos < 2
    },
  })
}

export function useGuardarConfiguracion() {
  const api = useApi()
  const qc = useQueryClient()
  return useMutation<{ ok: boolean; valores: Record<string, unknown> }, ErrorApi, Record<string, unknown>>({
    mutationFn: (cambios) => api.pedir(RUTA, { metodo: 'POST', cuerpo: cambios }),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: ['configuracion'] })
    },
  })
}
